import React, { useRef, useMemo, useCallback } from 'react';
import { BingMapsView, LocationTarget, TARGETING_TYPE } from '@bingads-webui-react/bing-maps';

// @ts-ignore
import tooltip from './map-tooltip.pug';
import { MapShimmer } from './shimmer';
import { TopLocationsMapProps, LocationData } from '../utils/types';
import { useMapStyles } from '../styles/map-styles';

class TopLocationTarget extends LocationTarget {
  topLocation: LocationData;

  constructor(topLocation: LocationData) {
    const location = {
      GeoPoint: topLocation.location,
      ExpandedName: topLocation.name,
    };
    super(location, TARGETING_TYPE.Top, topLocation.radius, 'mi');
    this.topLocation = topLocation;
  }
}

export function TopLocationsMap({
  isLoading,
  locations,
}: TopLocationsMapProps) {
  const styles = useMapStyles();
  const mapRef = useRef();

  const locationTargets = useMemo(() => {
    if (locations) {
      return locations.map(l => new TopLocationTarget(l));
    }
    return [];
  }, [locations]);

  const onGetTooltipHtmlContent = useCallback((event, locationTarget) => tooltip({
    name: locationTarget.topLocation.name,
    metricName: `${locationTarget.topLocation.metricName}:`,
    formattedValue: locationTarget.topLocation.formattedValue,
    date: locationTarget.topLocation.date,
  }), []);

  if (isLoading) {
    return <MapShimmer />;
  }

  return (
    <div className={styles.container}>
      <BingMapsView
        id="top-locations-map"
        ref={mapRef}
        className="top-locations-map"
        locationTargets={locationTargets}
        onGetTooltipHtmlContent={onGetTooltipHtmlContent}
      />
    </div>
  );
}
